import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../contexts/AuthContext";

function GuestRedirect() {
  useEffect(() => {
    toast.error("Ev sahibi paneline erisim yetkiniz yok veya hesabiniz onay asamasinda.");
  }, []);
  return <Navigate to="/" replace />;
}

function ForbiddenRedirect() {
  useEffect(() => {
    toast.error("Bu alana erisim yetkiniz bulunmuyor.");
  }, []);
  return <Navigate to="/host" replace />;
}

export default function RequireAuth({ allowedRoles = null }) {
  const location = useLocation();
  const { isAuthenticated, loading: authLoading, refreshAuth, user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    let alive = true;

    if (authLoading) {
      return () => {
        alive = false;
      };
    }

    if (isAuthenticated) {
      setAuthorized(true);
      setUserRole(user?.role || "guest");
      setLoading(false);
      return () => {
        alive = false;
      };
    }

    refreshAuth(true)
      .then((nextUser) => {
        if (!alive) return;
        setAuthorized(!!nextUser);
        setUserRole(nextUser?.role || null);
      })
      .finally(() => {
        if (!alive) return;
        setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, [authLoading, isAuthenticated, refreshAuth, user]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "40vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#475569",
          fontSize: "15px",
        }}
      >
        Oturum kontrol ediliyor...
      </div>
    );
  }

  if (!authorized) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search || ""}`, sessionExpired: true }}
      />
    );
  }

  // Eger kullanici guest ise ve host (veya admin) alanlarina erismeye calisiyorsa engelle
  if (userRole === "guest" && location.pathname.startsWith("/host")) {
    return <GuestRedirect />;
  }

  if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    const normalizedRole = String(userRole || "").toLowerCase();
    const normalizedAllowedRoles = allowedRoles.map((role) => String(role).toLowerCase());
    if (!normalizedAllowedRoles.includes(normalizedRole)) {
      return <ForbiddenRedirect />;
    }
  }

  return <Outlet />;
}
